import { useId } from "react";
import { LeftLaurelLeafDesktop } from "./left-laurel-leaf-desktop.component";

type LeftLaurelLeafProps = {
	width?: string;
	height?: string;
	size?: "xs" | "xs-mobile" | "sm" | "md";
	className?: string;
};

export function LeftLaurelLeaf({
	width = "25px",
	height = "49px",
	size,
	className,
}: LeftLaurelLeafProps) {
	const id = useId().replace(/:/g, "_");
	const usesCssVarSize = width.includes("var(") || height.includes("var(");
	const svgStyle = usesCssVarSize ? { width, height } : undefined;

	if (size === "xs" || size === "xs-mobile") {
		return (
			<LeftLaurelLeafDesktop
				width={width}
				height={height}
				className={className}
			/>
		);
	}

	const clipPathId = `clip0_${id}`;
	const gradientId = `paint0_linear_${id}`;

	return (
		<svg
			width={usesCssVarSize ? undefined : width}
			height={usesCssVarSize ? undefined : height}
			viewBox="0 0 25 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={svgStyle}
			aria-hidden="true"
		>
			<g clipPath={`url(#${clipPathId})`}>
				<path
					d="M1.46032 18.1118C1.65208 18.1135 1.88682 18.2548 2.06039 18.3563C5.18804 20.1799 7.44533 23.4922 8.03548 27.1259C7.94208 25.6533 7.84868 24.1807 7.75611 22.7081C7.72057 22.1414 7.66188 21.3285 7.4288 20.8507C7.19571 20.3728 6.71384 19.971 6.28817 19.4753C3.62752 16.377 3.18367 11.4915 5.26243 7.9517C5.31284 7.86543 5.46989 7.69372 5.55006 7.63536C5.98979 7.31902 6.31792 7.85866 6.5601 8.25536C8.27188 11.0576 9.01659 14.4655 8.63555 17.7473C9.32737 16.2197 10.0357 14.6016 9.88694 12.9244C9.81751 12.1445 9.56294 11.3934 9.41085 10.6161C8.67192 6.85973 10.6986 2.70923 14.1056 1.09623C14.1453 1.07762 14.1891 1.06747 14.2329 1.06578C14.7082 1.05224 14.7578 1.40326 14.7735 1.70184C14.9173 4.4305 14.2817 7.19722 12.9642 9.57485C14.1048 8.41183 14.5478 7.9018 15.3719 6.48587C16.1951 5.06995 16.6663 3.00865 18.264 1.81265C20.8982 -0.158143 24.1019 -0.157297 24.3457 0.170886C24.7523 0.718986 23.2745 4.1353 20.3841 6.02236C19.1914 6.80137 17.4234 7.4036 16.1687 8.0735C14.914 8.7434 13.7014 9.66282 13.1344 10.9891C15.319 9.50888 18.0573 8.90918 20.6428 9.34479C20.8221 9.37524 21.0271 9.42514 20.9808 9.76348C20.9783 9.78039 20.9726 9.79731 20.9643 9.81169C19.255 12.7653 16.215 14.8681 12.903 15.401C12.1128 15.5278 11.2408 15.6014 10.6697 16.1749C10.2589 16.5868 10.0878 17.1823 9.94563 17.7524C9.47284 19.6496 9.15132 21.5857 8.98518 23.5362C9.53979 20.5749 11.8384 18.0298 14.6792 17.2305C14.8313 17.1882 15.0115 17.1061 15.138 17.2965C15.2025 17.392 15.1719 17.853 15.1661 17.9697C15.0074 21.3429 13.5593 24.3296 11.1458 26.6319C10.5895 27.1623 9.94811 27.7112 9.8266 28.4792C9.75635 28.925 9.87785 29.3775 10.0126 29.808C10.7251 32.0765 11.8616 34.2038 13.3419 36.0435C11.874 33.2083 12.0029 29.572 13.6882 26.8628C13.7758 26.7224 13.923 26.4856 14.0734 26.4222C14.3693 26.297 14.633 26.6801 14.7958 26.9212C16.672 29.7048 17.3415 33.3098 16.5927 36.6034C16.4282 37.3275 16.2001 38.093 16.439 38.795C16.6431 39.393 17.1498 39.8227 17.6532 40.1923C19.484 41.5363 21.5164 42.4228 23.6853 43.0106C24.1151 43.1273 24.1663 43.1248 24.1886 43.1815C24.3283 43.5393 23.6497 44.4841 23.5365 44.4798C23.2604 44.4705 21.571 43.9622 20.8816 43.8269C19.8939 43.6323 18.9169 44.1153 17.9631 44.4418C14.1775 45.7384 9.91091 44.7006 7.35937 41.4822C7.35441 41.4763 7.3511 41.4687 7.34862 41.4619C7.19737 41.0001 7.63461 40.907 7.94291 40.8081C10.9201 39.8497 14.2478 40.0815 17.0713 41.4441C15.6909 40.6778 14.7652 39.1892 13.3204 38.5599C12.3178 38.1234 11.1896 38.1555 10.1093 38.0134C6.49646 37.5364 3.2407 34.8703 2.00584 31.361C1.9703 31.2595 1.88517 30.8594 1.88682 30.752C1.89426 30.0465 2.83073 30.2411 3.45147 30.3603C6.47497 30.9431 9.27282 32.6796 11.1747 35.1537C10.5879 33.9653 10.0018 32.776 9.41499 31.5877C9.19265 31.136 8.97361 30.4974 8.48347 30.11C7.88753 29.6389 7.48335 29.6355 6.8808 29.3631C2.97042 27.5962 0.48252 22.994 1.12475 18.6633C1.14128 18.5542 1.21814 18.1085 1.4628 18.111L1.46032 18.1118Z"
					fill={`url(#${gradientId})`}
				/>
				<path
					d="M22.5001 1.57837C21.3909 2.19752 20.309 2.87419 19.3262 3.69295C18.3443 4.51679 17.5706 5.54786 16.6573 6.44275C16.7771 6.33787 16.897 6.23299 17.0143 6.12472C17.8335 5.36939 18.5393 4.49311 19.4006 3.78515C20.3693 2.96131 21.443 2.27787 22.4993 1.57837H22.5001Z"
					fill="#E55C3C"
				/>
				<path
					d="M13.7156 2.33374C11.8749 4.55151 10.8409 7.44426 10.8103 10.3514C10.8086 10.7667 10.8218 11.1812 10.8599 11.5931C10.8483 11.1795 10.8466 10.765 10.8673 10.3531C10.9822 7.46118 12.0021 4.63356 13.7148 2.33374H13.7156Z"
					fill="#E55C3C"
				/>
			</g>
			<defs>
				<linearGradient
					id={gradientId}
					x1="14.1527"
					y1="22.4966"
					x2="2.7208"
					y2="22.4966"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F87D55" />
					<stop offset="0.72" stopColor="#FA8861" />
				</linearGradient>
				<clipPath id={clipPathId}>
					<rect
						width="25"
						height="45"
						fill="white"
						transform="matrix(-1 0 0 1 25 0)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
